











































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class SosialEkonomiSection extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: any;
  @Prop({ default: false }) readonly disabled!: boolean;

  form: any = {
    penampilan: "rapi",
    perilaku: "kooperatif",
    status_pernikahan: "menikah",
    hubungan_keluarga: "baik",
    tempat_tinggal: "rumah_sendiri"
  };

  created() {
    if (this.value && typeof this.value === "object") {
      this.form = { ...this.form, ...this.value };
    }
  }


  @Watch("form", { deep: true })
  onFormChange(val: any) { this.$emit("input", { ...val }); }

  syncFromValue(val: any) {
    if (!val) return;
    this.form = { ...this.form, ...val };
  }
}
